import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {AngularMultiSelectModule} from '../../angular2-multiselect-dropdown/multiselect.component';
import {DatetimeModule} from '../../datetime/datetime.module';
import {FieldsModule} from '../../fields/fields.module';

import {CommonComponentsModule} from '../../../common-components.module';
import {AngularMaterialImportModule} from '../../angular-material-import-module/angular-material-import.module';
import {MoveOutModalComponent} from './move-out-modal.component';
import {UtilsModule} from '../../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        AngularMultiSelectModule,
        DatetimeModule,
        CommonComponentsModule,
        AngularMaterialImportModule,
        FieldsModule,
        UtilsModule
    ],
    declarations: [
        MoveOutModalComponent
    ],
    exports: [
        MoveOutModalComponent
    ],
    providers: [],
})
export class MoveOutModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/move-out-modal/move-out-modal.module.ts